import React from "react";
import { useCmsSection } from "@/hooks/useCmsContent";
import ImageUploader from "@/components/cms/ImageUploader";
import styles from './offers.module.css';
import { useNavigate } from "react-router-dom";

const OFFERS_FALLBACKS = {
    title: 'Kwik Fill',
    body: 'Operation Give Thanks Giveaway!',
    cta_text: 'Enter Now',
    cta_link: '/win',
    image_url: 'https://operation-give-thanks.s3.us-east-1.amazonaws.com/website/january.png',
};

export default function HomeOffers() {
    const { fields, refetch } = useCmsSection('home', 'offers', OFFERS_FALLBACKS);
    const navigate = useNavigate();

    return (
        <div className={styles.container} onClick={() => navigate(fields.cta_link)}>
            <ImageUploader page="home" section="offers" field="image_url" currentUrl={fields.image_url}>
                <div className={styles.container_inner} style={{ backgroundImage: `url(${fields.image_url})` }}>
                </div>
            </ImageUploader>
        </div>
    );
}
